





































































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  watch,
  ref,
  onMounted,
  onUnmounted,
} from '@vue/composition-api';
import { ErrorCircleFilledIcon } from 'tdesign-icons-vue';

// 引入组件
import TeamPay from '@/renderer/components/teamPay/index.vue';
import Drawer from '@/renderer/components/drawer/index.vue';
import FilterDrawer from '@/renderer/components/drawer/FilterDrawer/index.vue';
import MobileDetailEtc from '@/renderer/components/MobileDetailEtc/index.vue';
import DragWidget from '@/renderer/components/SpacePage/dragWidget.vue';
import GuideAndHelp from '@/renderer/components/GuideAndHelp/index.vue';
// eslint-disable-next-line import/no-cycle
import UserSurveyDialog from '@/renderer/components/dialog/UserSurvey/UserSurveyDialog.vue';
import SurveyResultDialog from '@/renderer/components/dialog/UserSurvey/SurveyResultDialog.vue';
import MobileUserSurvey from '@/renderer/components/mobile/MobileUserSurvey/index.vue';
import MobileWeclome from '@/renderer/components/mobile/MobileWeclome/index.vue';
import InviteMember from '@/renderer/views/desktop/FileManagement/Workbench/components/Welcome/components/InviteMember/index.vue';
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import surveryHandler from '@/renderer/views/composition/pc/guide/surveyHandler';
import mobileGuideHandler from '@/renderer/views/composition/mobile/guide/mobileGuideHandler';
import smh from '@/renderer/scripts/smh/smh';
import user from '@/renderer/scripts/utils/user';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import ipc from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
import { adminRouterName } from '@/renderer/scripts/utils/tools';
import headbar from './headbar/index.vue';
import BaseSideBar from './BaseSidebar/index.vue';
export default defineComponent({
  name: 'desktop',
  components: {
    headbar,
    BaseSideBar,
    Drawer,
    TeamPay,
    FilterDrawer,
    MobileDetailEtc,
    DragWidget,
    GuideAndHelp,
    UserSurveyDialog,
    SurveyResultDialog,
    InviteMember,
    MobileUserSurvey,
    MobileWeclome,
    ErrorCircleFilledIcon,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const showMobileSurvey = ref(false);
    surveryHandler();
    mobileGuideHandler();
    const close = () => {
      showMobileSurvey.value = false;
    };
    const getSurveyInfo = async () => {
      const { userRole } = user.getUserInfo();
      const { isInWeMeetApp, isMobile, editionFlag } = store.getters;
      if (editionFlag === 'personal') return;
      if (userRole !== RoleMap.SuperAdmin || !isInWeMeetApp || !isMobile) {
        showMobileSurvey.value = false;
        return;
      }
      try {
        const { data = [] } = await smh.userAPI.getSurvey({
          type: 'create-industry-info',
        });
        if (data.length === 0) {
          showMobileSurvey.value = true;
          reporter.report('meeting_message', {
            banner: 'show',
          });
          return;
        }
        showMobileSurvey.value = false;
      } catch (e) {
        tips.error(e as MsgError);
      }
    };
    const showSidebarMenu = computed(() => {
      const route = ['doc', 'media', 'edit'];
      return !route.includes(vm.$route.name as string);
    });
    const hideHeaderHight = computed(() => {
      // 电子签的需要隐藏高度
      const route = ['electronicSign', 'fileCollect'];
      return !route.includes(vm.$route.name as string);
    });

    const adminHideHeaderBar = computed(() => adminRouterName.includes(vm.$route.name as string));

    // 抽屉是否显示
    const show = computed(() => vm.$store.state.drawer.show);
    const alive = computed(() => vm.$store.state.drawer.alive);
    vm.$store.dispatch('GetRoles'); // 登录成功获取共享授权角色列表

    const isFixedDrawer = ref(false);
    // 切换路由要重置抽屉
    watch(
      () => vm.$route.name,
      newVal => {
        // 当路由是回收站的就不展示drawer
        isFixedDrawer.value = newVal === 'recycleBin' || newVal === 'suspiciousFile';
      },
      {
        immediate: true,
      },
    );
    // 当警告出来的时候需要将高度改变
    const height = computed(() => {
      let val = '';
      if (vm.$store.getters.warningShow) {
        val = '105px';
      } else {
        val = '80px';
      }
      return val;
    });
    const showTeamPay = computed(() => vm.$store.getters.teamPay.show);
    const toFill = () => {
      reporter.report('meeting_message', {
        banner: 'click',
      });
      ipc.emit(ipc.RENDERER_EVENTS_MAP.START_MOBILE_USER_SURVEY);
    };

    // 是否展示品牌图
    const showBrandFigureList = [
      'initializeSettings',
      'uiDesign',
      'accountAssociation',
      'customDomain',
      'watermark',
      'versionManagement',
      'securityScan',
    ];
    const shouldShowBackground = computed(() => {
      const menuValue = vm.$route.meta?.routerParent || vm.$route.name || '';
      return showBrandFigureList.includes(menuValue);
    });
    const banRouteInMobile = [
      'workbench',
      'relatedToMe',
      'recycleBin',
      'spaceStatistics',
      'userStatistics',
      'trafficStatistics',
      'userManagement',
      'teamManagement',
      'initializeSettings',
      'uiDesign',
      'accountAssociation',
      'watermark',
      'consoleLinkManagement',
      'versionManagement',
      'logQuery',
    ];
    watch(
      () => store.getters.isMobileStyle,
      val => {
        setTimeout(() => {
          if (store.getters.isMobileStyle && banRouteInMobile.includes(vm.$route.name as string)) {
            checkIfMobileStyle();
          }
        }, 200);
      },
    );
    onMounted(() => {
      getSurveyInfo();
      ipc.on(ipc.RENDERER_EVENTS_MAP.FINISH_MOBILE_SURVEY, close);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.FINISH_MOBILE_SURVEY, close);
    });
    return {
      toFill,
      showMobileSurvey,
      showSidebarMenu,
      adminHideHeaderBar,
      hideHeaderHight,
      show,
      alive,
      height,
      isFixedDrawer,
      showTeamPay,
      shouldShowBackground,
    };
  },
});
